import { render, staticRenderFns } from "./WaveDetailsPanel.vue?vue&type=template&id=4f683fa5&scoped=true&"
import script from "./WaveDetailsPanel.vue?vue&type=script&lang=js&"
export * from "./WaveDetailsPanel.vue?vue&type=script&lang=js&"
import style0 from "./WaveDetailsPanel.vue?vue&type=style&index=0&id=4f683fa5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f683fa5",
  null
  
)

export default component.exports